import React from 'react';

import SettingsForm from '../../../CustomizeGoalPage/SettingsForm/SettingsForm';

const FormContentSection = ({ groupFormData, setGroupFormData, isEditable }) => {
    return (
        <SettingsForm
            formData={groupFormData}
            setFormData={setGroupFormData}
            containerGap={20}
            displayStyle="inline-tooltip"
            isFormDisabled={!isEditable}
        />
    );
};

export default FormContentSection;
